import axios from 'axios'

/**
 * 86bc8uyd2: opens Plaid Link for the Applicant Boost. `Plaid` is the global
 * from link-initialize.js, loaded in app.blade.php.
 */
export function openPlaidLink(linkToken, { onSuccess, onExit = () => {} }) {
    const handler = window.Plaid.create({
        token: linkToken,
        onSuccess,
        onExit,
    })

    handler.open()
}

/**
 * 86bc8uyd2: runs Plaid identity verification for the Applicant Boost right
 * from the report dashboard and records it against the report.
 *
 * `setBusy` is on while talking to our server and off while Plaid's own
 * window is open. Resolves true once a result was submitted, false if the
 * renter closed Plaid or no link token could be made.
 */
export async function verifyIdentityWithPlaid(reportId, { setBusy = () => {} } = {}) {
    setBusy(true)

    let linkToken
    try {
        await axios.get('/sanctum/csrf-cookie')
        const response = await axios.post(route('plaid.create-link-token'), {
            product: 'identity_verification',
        })
        linkToken = response.data.status ? response.data.public_token : null
    } finally {
        setBusy(false)
    }

    if (!linkToken) {
        return false
    }

    return new Promise((resolve) => {
        openPlaidLink(linkToken, {
            onSuccess: async (publicToken, metadata) => {
                setBusy(true)
                try {
                    await axios.post(route('reports.boost.identity.submit', reportId), { metadata })
                } catch (error) {
                    console.error('Error:', error.response ? error.response.data : error.message)
                } finally {
                    setBusy(false)
                    resolve(true)
                }
            },
            onExit: () => resolve(false),
        })
    })
}
